import { i18n } from '@/plugins/i18next'

/**
 * Utils class which includes all state fields
 * [0].values ... translatedName e.g. CONCRETE -> Beton or Concrete
 * [1].values ... boolean field if state is successfull or not
 * [2].values ... note field, if any additional note is required for this step
 * [3].values ... documentation field to upload multiple docus for a specific state
 * [4].values ... the original enum of the state
 */
export default class StateTableUtils {
  static getElevatorStateCarFieldsAndTranslation() {
    return [
      {
        values: [
          i18n.i18next.t('enums:facility-documentation-types.CAR_RIDE_COMFORT'),
          i18n.i18next.t('enums:facility-documentation-types.CAR_DOOR_RUN_PROPS'),
          i18n.i18next.t('enums:facility-documentation-types.CAR_SAFETY_GRID_LIGHT_BARRIER'),
          i18n.i18next.t('enums:facility-documentation-types.CAR_REVERSING_DEVICE'),
          i18n.i18next.t('enums:facility-documentation-types.CAR_OPEN_DOOR_BUTTON'),
          i18n.i18next.t('enums:facility-documentation-types.CAR_SIGN'),
          i18n.i18next.t('enums:facility-documentation-types.CAR_EMERGENCY_CALL'),
          i18n.i18next.t('enums:facility-documentation-types.CAR_CABIN_FLOOR'),
          i18n.i18next.t('enums:facility-documentation-types.CAR_BASEBOARD_WALL_CEILING'),
          i18n.i18next.t('enums:facility-documentation-types.CAR_STOP_SWITCH'),
          i18n.i18next.t('enums:facility-documentation-types.CAR_CONTROL_PANELS'),
          i18n.i18next.t('enums:facility-documentation-types.CAR_LIGHTING'),
          i18n.i18next.t('enums:facility-documentation-types.CAR_VENTILATION')
        ]
      },
      {
        values: [
          "carRideComfort",
          "carDoorRunProps",
          "carSafetyGridLightBarrier",
          "carReversingDevice",
          "carOpenDoorButton",
          "carSign",
          "carEmergencyCall",
          "carCabinFloor",
          "carBaseboardWallCeiling",
          "carStopSwitch",
          "carControlPanels",
          "carLighting",
          "carVentilation"
        ]
      },
      {
        values: [
          "carRideComfortNote",
          "carDoorRunPropsNote",
          "carSafetyGridLightBarrierNote",
          "carReversingDeviceNote",
          "carOpenDoorButtonNote",
          "carSignNote",
          "carEmergencyCallNote",
          "carCabinFloorNote",
          "carBaseboardWallCeilingNote",
          "carStopSwitchNote",
          "carControlPanelsNote",
          "carLightingNote",
          "carVentilationNote"
        ]
      },
      {
        values: [
          "carRideComfortDocs",
          "carDoorRunPropsDocs",
          "carSafetyGridLightBarrierDocs",
          "carReversingDeviceDocs",
          "carOpenDoorButtonDocs",
          "carSignDocs",
          "carEmergencyCallDocs",
          "carCabinFloorDocs",
          "carBaseboardWallCeilingDocs",
          "carStopSwitchDocs",
          "carControlPanelsDocs",
          "carLightingDocs",
          "carVentilationDocs"
        ]
      },
      {
        values: [
          "CAR_RIDE_COMFORT",
          "CAR_DOOR_RUN_PROPS",
          "CAR_SAFETY_GRID_LIGHT_BARRIER",
          "CAR_REVERSING_DEVICE",
          "CAR_OPEN_DOOR_BUTTON",
          "CAR_SIGN",
          "CAR_EMERGENCY_CALL",
          "CAR_CABIN_FLOOR",
          "CAR_BASEBOARD_WALL_CEILING",
          "CAR_STOP_SWITCH",
          "CAR_CONTROL_PANELS",
          "CAR_LIGHTING",
          "CAR_VENTILATION"
        ]
      }
    ]
  }

  static getElevatorStateStopFieldsAndTranslation() {
    return [
      {
        values: [
          i18n.i18next.t('enums:facility-documentation-types.STOP_INFO_SIGNS'),
          i18n.i18next.t('enums:facility-documentation-types.STOP_CONCISENESS'),
          i18n.i18next.t('enums:facility-documentation-types.STOP_SIGNALS'),
          i18n.i18next.t('enums:facility-documentation-types.STOP_SHAFT_DOOR_LOCKS'),
          i18n.i18next.t('enums:facility-documentation-types.STOP_GLASS_DOOR'),
          i18n.i18next.t('enums:facility-documentation-types.STOP_GLASS_DOOR_DAMAGE'),
          i18n.i18next.t('enums:facility-documentation-types.STOP_REVOLVING_DOOR'),
          i18n.i18next.t('enums:facility-documentation-types.STOP_SIGNALS_OUTDOOR_PANELS'),
          i18n.i18next.t('enums:facility-documentation-types.STOP_DOOR_AUTOMATIC_CLOSING'),
          i18n.i18next.t('enums:facility-documentation-types.STOP_DOOR_SILL')
        ]
      },
      {
        values: [
          "stopInfoSigns",
          "stopConciseness",
          "stopSignals",
          "stopShaftDoorLocks",
          "stopGlassDoor",
          "stopGlassDoorDamage",
          "stopRevolvingDoorSafety",
          "stopSignalsOutdoorPanels",
          "stopDoorAutomaticClosing",
          "stopDoorSill"
        ]
      },
      {
        values: [
          "stopInfoSignsNote",
          "stopConcisenessNote",
          "stopSignalsNote",
          "stopShaftDoorLocksNote",
          "stopGlassDoorNote",
          "stopGlassDoorDamageNote",
          "stopRevolvingDoorSafetyNote",
          "stopSignalsOutdoorPanelsNote",
          "stopDoorAutomaticClosingNote",
          "stopDoorSillNote"
        ]
      },
      {
        values: [
          "stopInfoSignsDocs",
          "stopConcisenessDocs",
          "stopSignalsDocs",
          "stopShaftDoorLocksDocs",
          "stopGlassDoorDocs",
          "stopGlassDoorDamageDocs",
          "stopRevolvingDoorSafetyDocs",
          "stopSignalsOutdoorPanelsDocs",
          "stopDoorAutomaticClosingDocs",
          "stopDoorSillDocs"
        ]
      },
      {
        values: [
          "STOP_INFO_SIGNS",
          "STOP_CONCISENESS",
          "STOP_SIGNALS",
          "STOP_SHAFT_DOOR_LOCKS",
          "STOP_GLASS_DOOR",
          "STOP_GLASS_DOOR_DAMAGE",
          "STOP_REVOLVING_DOOR",
          "STOP_SIGNALS_OUTDOOR_PANELS",
          "STOP_DOOR_AUTOMATIC_CLOSING",
          "STOP_DOOR_SILL"
        ]
      }
    ]
  }

  static getElevatorStateERFieldsAndTranslation() {
    return [
      {
        values: [
          i18n.i18next.t('enums:facility-documentation-types.ER_SAFE_ACCESS'),
          i18n.i18next.t('enums:facility-documentation-types.ER_CLOSURE_MARKING'),
          i18n.i18next.t('enums:facility-documentation-types.ER_LIGHTING_SOCKETS'),
          i18n.i18next.t('enums:facility-documentation-types.ER_FLOOR_WALL'),
          i18n.i18next.t('enums:facility-documentation-types.ER_COVERS'),
          i18n.i18next.t('enums:facility-documentation-types.ER_POWER_UNIT'),
          i18n.i18next.t('enums:facility-documentation-types.ER_GEAR'),
          i18n.i18next.t('enums:facility-documentation-types.ER_BREAK'),
          i18n.i18next.t('enums:facility-documentation-types.ER_ROLLS'),
          i18n.i18next.t('enums:facility-documentation-types.ER_SPEED_LIMITER'),
          i18n.i18next.t('enums:facility-documentation-types.ER_VENTILATION'),
          i18n.i18next.t('enums:facility-documentation-types.ER_CLEANLINESS')
        ]
      },
      {
        values: [
          "erSafeAccess",
          "erClosureMarking",
          "erLightingSockets",
          "erFloorWall",
          "erCovers",
          "erPowerUnit",
          "erGear",
          "erBreak",
          "erRolls",
          "erSpeedLimiter",
          "erVentilation",
          "erCleanliness"
        ]
      },
      {
        values: [
          "erSafeAccessNote",
          "erClosureMarkingNote",
          "erLightingSocketsNote",
          "erFloorWallNote",
          "erCoversNote",
          "erPowerUnitNote",
          "erGearNote",
          "erBreakNote",
          "erRollsNote",
          "erSpeedLimiterNote",
          "erVentilationNote",
          "erCleanlinessNote"
        ]
      },
      {
        values: [
          "erSafeAccessDocs",
          "erClosureMarkingDocs",
          "erLightingSocketsDocs",
          "erFloorWallDocs",
          "erCoversDocs",
          "erPowerUnitDocs",
          "erGearDocs",
          "erBreakDocs",
          "erRollsDocs",
          "erSpeedLimiterDocs",
          "erVentilationDocs",
          "erCleanlinessDocs"
        ]
      },
      {
        values: [
          "ER_SAFE_ACCESS",
          "ER_CLOSURE_MARKING",
          "ER_LIGHTING_SOCKETS",
          "ER_FLOOR_WALL",
          "ER_COVERS",
          "ER_POWER_UNIT",
          "ER_GEAR",
          "ER_BREAK",
          "ER_ROLLS",
          "ER_SPEED_LIMITER",
          "ER_VENTILATION",
          "ER_CLEANLINESS"
        ]
      }
    ]
  }

  static getElevatorStateShaftFieldsAndTranslation() {
    return [
      {
        values: [
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_EMERGENCY_BRAKE_SWITCH'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_INSPECTION_CONTROL'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_EMERGENCY_CALL_DEVICE'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_SWITCH'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_RAIL_BRACKETS_SCREW_FITTINGS'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_SAFETY_GEAR'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_SLIDING_BLOCKS_DUCT'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_DOOR_CONTACT'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_DOOR_MECHANICS'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_SUSPENSION'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_CABIN_APRON'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_FALL_PROTECTION_ON_ROOF'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_LIGHTING'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_CABIN_ROOF_CLEANLINESS'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_CLEANLINESS'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_SLIDING_BLOCKS_DUCT_COUNTERWEIGHT'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_BOTTOM_ROPE_ATTACHMENT_COUNTERWEIGHT'),
        ]
      },
      {
        values: [
          "shaftEmergencyBrakeSwitch",
          "shaftInspectionControl",
          "shaftEmergencyCallDevice",
          "shaftSwitch",
          "shaftRailBracketsScrewFittings",
          "shaftSafetyGear",
          "shaftSlidingBlocksDuct",
          "shaftDoorContact",
          "shaftDoorMechanics",
          "shaftSuspension",
          "shaftCabinApron",
          "shaftFallProtectionOnRoof",
          "shaftLighting",
          "shaftCabinRoofCleanliness",
          "shaftCleanliness",
          "shaftSlidingBlocksDuctCounterweight",
          "shaftBottomRopeAttachmentCounterweight"
        ]
      },
      {
        values: [
          "shaftEmergencyBrakeSwitchNote",
          "shaftInspectionControlNote",
          "shaftEmergencyCallDeviceNote",
          "shaftSwitchNote",
          "shaftRailBracketsScrewFittingsNote",
          "shaftSafetyGearNote",
          "shaftSlidingBlocksDuctNote",
          "shaftDoorContactNote",
          "shaftDoorMechanicsNote",
          "shaftSuspensionNote",
          "shaftCabinApronNote",
          "shaftFallProtectionOnRoofNote",
          "shaftLightingNote",
          "shaftCabinRoofCleanlinessNote",
          "shaftCleanlinessNote",
          "shaftSlidingBlocksDuctCounterweightNote",
          "shaftBottomRopeAttachmentCounterweightNote"
        ]
      },
      {
        values: [
          "shaftEmergencyBrakeSwitchDocs",
          "shaftInspectionControlDocs",
          "shaftEmergencyCallDeviceDocs",
          "shaftSwitchDocs",
          "shaftRailBracketsScrewFittingsDocs",
          "shaftSafetyGearDocs",
          "shaftSlidingBlocksDuctDocs",
          "shaftDoorContactDocs",
          "shaftDoorMechanicsDocs",
          "shaftSuspensionDocs",
          "shaftCabinApronDocs",
          "shaftFallProtectionOnRoofDocs",
          "shaftLightingDocs",
          "shaftCabinRoofCleanlinessDocs",
          "shaftCleanlinessDocs",
          "shaftSlidingBlocksDuctCounterweightDocs",
          "shaftBottomRopeAttachmentCounterweightDocs"
        ]
      },
      {
        values: [
          "SHAFT_EMERGENCY_BRAKE_SWITCH",
          "SHAFT_INSPECTION_CONTROL",
          "SHAFT_EMERGENCY_CALL_DEVICE",
          "SHAFT_SWITCH",
          "SHAFT_RAIL_BRACKETS_SCREW_FITTINGS",
          "SHAFT_SAFETY_GEAR",
          "SHAFT_SLIDING_BLOCKS_DUCT",
          "SHAFT_DOOR_CONTACT",
          "SHAFT_DOOR_MECHANICS",
          "SHAFT_SUSPENSION",
          "SHAFT_CABIN_APRON",
          "SHAFT_FALL_PROTECTION_ON_ROOF",
          "SHAFT_LIGHTING",
          "SHAFT_CABIN_ROOF_CLEANLINESS",
          "SHAFT_CLEANLINESS",
          "SHAFT_SLIDING_BLOCKS_DUCT_COUNTERWEIGHT",
          "SHAFT_BOTTOM_ROPE_ATTACHMENT_COUNTERWEIGHT"
        ]
      }
    ]
  }

  static getElevatorStateShaftPitFieldsAndTranslation() {
    return [
      {
        values: [
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_PIT_OPTICAL_BUFFER'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_PIT_TENSION_WEIGHT_SPEED_LIMITER'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_PIT_GOVERNOR_TENSION_WEIGHT_SWITCH'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_PIT_EMERGENCY_BRAKE_SWITCH'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_PIT_SUSPENSION_CABLE'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_PIT_FLOOR_CLEANLINESS'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_PIT_LADDER'),
          i18n.i18next.t('enums:facility-documentation-types.SHAFT_PIT_COUNTERWEIGHT_CLADDING')
        ]
      },
      {
        values: [
          "shaftPitOpticalBuffer",
          "shaftPitTensionWeightSpeedLimiter",
          "shaftPitGovernorTensionWeightSwitch",
          "shaftPitEmergencyBrakeSwitch",
          "shaftPitSuspensionCable",
          "shaftPitFloorCleanliness",
          "shaftPitLadder",
          "shaftPitCounterweightCladding"
        ]
      },
      {
        values: [
          "shaftPitOpticalBufferNote",
          "shaftPitTensionWeightSpeedLimiterNote",
          "shaftPitGovernorTensionWeightSwitchNote",
          "shaftPitEmergencyBrakeSwitchNote",
          "shaftPitSuspensionCableNote",
          "shaftPitFloorCleanlinessNote",
          "shaftPitLadderNote",
          "shaftPitCounterweightCladdingNote"
        ]
      },
      {
        values: [
          "shaftPitOpticalBufferDocs",
          "shaftPitTensionWeightSpeedLimiterDocs",
          "shaftPitGovernorTensionWeightSwitchDocs",
          "shaftPitEmergencyBrakeSwitchDocs",
          "shaftPitSuspensionCableDocs",
          "shaftPitFloorCleanlinessDocs",
          "shaftPitLadderDocs",
          "shaftPitCounterweightCladdingDocs"
        ]
      },
      {
        values: [
          "SHAFT_PIT_OPTICAL_BUFFER",
          "SHAFT_PIT_TENSION_WEIGHT_SPEED_LIMITER",
          "SHAFT_PIT_GOVERNOR_TENSION_WEIGHT_SWITCH",
          "SHAFT_PIT_EMERGENCY_BRAKE_SWITCH",
          "SHAFT_PIT_SUSPENSION_CABLE",
          "SHAFT_PIT_FLOOR_CLEANLINESS",
          "SHAFT_PIT_LADDER",
          "SHAFT_PIT_COUNTERWEIGHT_CLADDING"
        ]
      }
    ]
  }
}
